import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { AuthProvider } from '../../Context/AuthContext';
import logo from '../../assets/img.jpg'

const HeroNavbar = () => {
    const [isOpen, setOpen] = useState(false)
    const { user, logout } = useContext(AuthProvider)
    const [admindata, setAdminData] = useState({})

    const [menuOpen, setMenuOpen] = useState(false)
    const [nav, setNav] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        function activateNav() {
            let scrollPosition = window.pageYOffset
            if (scrollPosition > 200) {
                setNav(true)
            }
            else if (scrollPosition < 10) {
                setNav(false)
            }
        }
        window.addEventListener("scroll", activateNav)
    }, [])

    const handleLogout = () => {
        logout()
            .then(() => {
                toast.success("Successfully Loged Out")
            })
    }

    const [data, setData] = useState({})

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/adminuser/${user?.email}`)
            .then(res => {
                console.log(res?.data)
                setAdminData(res?.data)
            })
            .catch(err => {
                console.log(err)
            })
    }, [user?.email])

    return (
        <div className={`w-full shadow-lg transition duration-300 z-30 ${nav && 'fixed top-0 ease-in duration-300 w-full shadow-lg transition z-30'}`}>
            <div className={`z-30 bg-white  print:hidden lg:py-4 py-4 transition ease-in-out `}>
                <nav class="relative dark:bg-gray-800 px-5 xl:px-0  max-w-6xl mx-auto ">
                    <div class="">
                        <div class="lg:flex lg:items-center lg:justify-between">
                            <div class="flex items-center justify-between">
                                <div class="text-xl font-semibold text-gray-700">
                                    <Link class="text-2xl font-semibold text-gray-800 transition-colors duration-300 transform dark:text-white lg:text-3xl hover:text-gray-700 dark:hover:text-gray-300 flex items-center gap-2" to='/'>
                                        <img src={logo} className='h-11 w-11' />
                                        <h3>Computer <span className='text-blue-500'>Plus</span></h3>
                                    </Link>
                                </div>

                                {/* <!-- Mobile menu button --> */}
                                <div class="flex lg:hidden">
                                    <button onClick={() => setOpen(!isOpen)} type="button" class="text-gray-500 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 focus:outline-none focus:text-gray-600 dark:focus:text-gray-400" aria-label="toggle menu">
                                        {
                                            isOpen ?
                                                <svg x-show="isOpen" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                    stroke-width="2">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                                :
                                                <svg x-show="!isOpen" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 8h16M4 16h16" />
                                                </svg>
                                        }
                                    </button>
                                </div>
                            </div>

                            {/* <!-- Mobile Menu open: "block", Menu closed: "hidden" --> */}
                            <div className={`absolute inset-x-0 z-20 w-full px-6 py-4 transition-all duration-300 ease-in-out bg-white dark:bg-gray-800 lg:mt-0 lg:p-0 lg:top-0 lg:relative lg:bg-transparent lg:w-auto lg:opacity-100 lg:translate-x-0 lg:flex lg:items-center  ${isOpen ? 'translate-x-0 opacity-100 ' : 'opacity-0 -translate-x-full'}`}>
                                <div class="flex flex-col md:-mx-6 lg:flex-row lg:items-center lg:mx-8">
                                    <Link onClick={() => setOpen(!isOpen)} to='/' class="px-3 py-2 mx-3 mt-2 text-gray-700 transition-colors duration-300 transform rounded-md lg:mt-0 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Home</Link>
                                    <Link onClick={() => setOpen(!isOpen)} to="/allcourse" class="px-3 py-2 mx-3 mt-2 text-gray-700 transition-colors duration-300 transform rounded-md lg:mt-0 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Courses</Link>
                                    <Link onClick={() => setOpen(!isOpen)} to='/contact' class="px-3 py-2 mx-3 mt-2 text-gray-700 transition-colors duration-300 transform rounded-md lg:mt-0 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Contact</Link>
                                    <a onClick={() => setOpen(!isOpen)} href='#services' class="px-3 py-2 mx-3 mt-2 text-gray-700 transition-colors duration-300 transform rounded-md lg:mt-0 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Services</a>

                                    <a onClick={() => setOpen(!isOpen)} href="#blogs" class="px-3 py-2 mx-3 mt-2 text-gray-700 transition-colors duration-300 transform rounded-md lg:mt-0 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Blogs</a>
                                    {
                                        user?.uid ?
                                            <Link onClick={handleLogout} class="px-3 py-2 mx-3 mt-2 text-gray-700 transition-colors duration-300 transform rounded-md lg:mt-0 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 ">Logout</Link>
                                            :
                                            undefined
                                    }
                                </div>

                                <div class="flex items-center mt-4 lg:mt-0">

                                    {
                                        user?.uid ?
                                            <div className='flex items-center'>
                                                <button  class="hidden mx-4 text-gray-600 transition-colors duration-300 transform lg:block dark:text-gray-200 hover:text-gray-700 dark:hover:text-gray-400 focus:text-gray-700 dark:focus:text-gray-400 focus:outline-none" aria-label="show notifications">
                                                    <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </button>

                                                <button type="button" class="flex items-center focus:outline-none" aria-label="toggle profile dropdown">
                                                    <Link tp='/profile'><div class="w-8 h-8 overflow-hidden border-2 border-gray-400 rounded-full">
                                                        <img src={user?.photoURL} class="object-cover w-full h-full" alt="avatar" />
                                                    </div></Link>

                                                    {/* <h3 class="mx-2 text-gray-700 dark:text-gray-200 lg:hidden">Khatab wedaa</h3> */}
                                                </button>
                                                {/* <div class="flex justify-center">
                                                    <div>
                                                        <div class="dropdown relative">
                                                            <button
                                                                class=" dropdown-toggle  "
                                                                type="button"
                                                                id="dropdownMenuButton1"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                Dropdown button
                                                            </button>
                                                            <ul
                                                                class=" dropdown-menu max-w-lg absolute hidden bg-white text-base z-50 float-left py-2 list-none text-left rounded-lg shadow-lg mt-1 hidden  m-0 bg-clip-padding border-none  "
                                                                aria-labelledby="dropdownMenuButton1"
                                                            >
                                                                <li>
                                                                    <a
                                                                        class="dropdown-item"
                                                                        href="#"
                                                                    >Action</a
                                                                    >
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                            :
                                            <Link onClick={() => setOpen(!isOpen)} to='/signin' className='block px-6 py-2.5 mt-4 font-medium leading-5 text-center text-white capitalize bg-blue-600 rounded-lg lg:mt-0 hover:bg-blue-500 lg:w-auto'>Sign In</Link>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </nav >
            </div >
        </div>
    );
};

export default HeroNavbar;




{/* <nav class="lg:flex lg:justify-between lg:items-center">
    <div class="flex items-center justify-between lg:hidden">
        <div className='flex items-center gap-3'>
            <h3><i class="text-4xl text-blue-500  fa-solid fa-computer"></i></h3>
            <p className="text-2xl font-bold ">
                COPlus
            </p>
        </div>
        <div class="flex lg:hidden">
            <button onClick={() => setOpen(!isOpen)} type="button" class="text-gray-500 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 focus:outline-none focus:text-gray-600 dark:focus:text-gray-400" aria-label="toggle menu">
                {
                    isOpen ?
                        <svg x-show="isOpen" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                            stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        :
                        <svg x-show="!isOpen" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4 8h16M4 16h16" />
                        </svg>
                }
            </button>
        </div>
    </div>
    <div className={`absolute inset-x-0 z-20 w-full px-6 py-4 transition-all duration-300 ease-in-out bg-gray-900 md:bg-transparent md:dark:bg-transparent md:mt-0 md:p-0 md:top-0 md:relative md:w-auto md:opacity-100 md:translate-x-0 md:flex md:items-center md:justify-between ${isOpen ? 'translate-x-0 opacity-100 ' : 'opacity-0 -translate-x-full'}`}>

        <div className='hidden md:block flex items-center gap-3'>
            <h3><i class="text-4xl text-blue-500  fa-solid fa-computer"></i></h3>
            <p className="text-2xl font-bold ">
                COPlus
            </p>
        </div>

        <div class="flex flex-col space-y-4 lg:mt-0 lg:flex-row lg:space-y-0">
            <a class="text-gray-700 font-bold hover:text-white lg:mr-9 dark:text-gray-200 " href="#">Home</a>
            <a class=" text-gray-700 font-bold lg:mx-9 " href="#">Components</a>
            <a class="text-gray-700 font-bold hover:text-white lg:mx-9 " href="#">Pricing</a>
            <Link to='/contact' class="text-gray-200 font-bold hover:text-white lg:mx-9 ">Contact</Link>
            <a class="text-gray-200 font-bold hover:text-white lg:mx-9" href="#">FAQ</a>
            <Link to='/contact' class="block h-10 px-5 py-2 mt-4 text-sm text-center text-gray-200 capitalize transition-colors duration-300 transform border rounded-md font-bold hover:text-gray-700 dark:text-gray-900 lg:mt-0 hover:bg-gray-100 lg:w-auto" >
                Contact Us
            </Link>
        </div>


    </div>
</nav > */}
